var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"edit-store"},[_c('div',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.currentStore))])]),_c('EditMenu'),_c('router-view',{staticClass:"content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }